<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">MY PAGE</h2>

            <p class="sub_descript">
                고객님의 개인정보 및 활동 내역을 확인하실 수 있습니다.
            </p>

            <div class="mypage_area personal">
                <ul class="sub_link_list">
                    <li>
                        <RouterLink to="/HFO_MP_003">1:1 문의 내역</RouterLink>
                    </li>
                    <li class="on">
                        <RouterLink to="/HFO_MP_005">개인정보관리</RouterLink>
                    </li>
                </ul>

                <p class="mypage_descript">고객님의 회원 정보를 변경 및 관리 할 수 있습니다.</p>

                <ul class="tab_list tab_col_4">
                    <li>
                        <RouterLink to="/HFO_MP_005">회원정보 <br class="pc_none">변경</RouterLink>
                    </li>
                    <!-- <li class="on"><RouterLink to="/HFO_MP_006">비밀번호 <br class="pc_none">변경</RouterLink></li> -->
                    <!-- <li class="on" v-if="loginInfo.inType == 'USER_IN_NORMAL'">
                        <RouterLink to="/HFO_MP_006">비밀번호 <br class="pc_none">변경</RouterLink>
                    </li> -->
                    <li>
                        <RouterLink to="/HFO_MP_007">마케팅정보 <br class="pc_none">수신동의</RouterLink>
                    </li>
                    <!-- <li><RouterLink to="/HFO_MP_008">회원 탈퇴</RouterLink></li> -->
                </ul>

                <div class="login_box_area">
                    <!-- <h3 class="title_login">
                        Hi-Vitamin<br>Membership
                    </h3> -->

                    <div class="login_input_area">
                        <p class="join_descript">
                            회원님의 정보 보호를 위해 <br>비밀번호를 정기적으로 변경해주세요.
                        </p>

                        <ul class="login_input_list">
                            <li>
                                <h3 class="title_input">기존 비밀번호</h3>

                                <InputText type="password" id="password" :placeholder="placeholderPw1" />

                                <p class="required">최소 8자 이상 입력해주세요.</p>
                            </li>
                            <li>
                                <h3 class="title_input">신규 비밀번호</h3>

                                <InputText type="password" id="passwordNew" :placeholder="placeholderPw2" />

                                <p class="required">최소 8자 이상 입력해주세요.</p>
                            </li>
                            <li>
                                <h3 class="title_input">신규 비밀번호 확인</h3>

                                <InputText type="password" id="passwordNewConf" :placeholder="placeholderPw3" />

                                <p class="required">최소 8자 이상 입력해주세요.</p>
                            </li>
                        </ul>

                        <div class="btn_login_area">
                            <button class="btn_type2" @click="handleChange()">변경</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" title="알림">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import InputText from '@/components/InputText'
import AlertPopup from '@/components/AlertPopup.vue';
import { postAxios } from '@/lib/AxiosCall';
import { useRoute, useRouter } from 'vue-router';
import { LOCAL_STORAGE_HVM_USERINFO } from '@/lib/Constant';

export default {
    components: {
        InputText,
        AlertPopup
    },
    data() {
        return {
            placeholderPw1: '기존 비밀번호를 입력해 주세요.',
            placeholderPw2: '영문, 숫자, 특수문자 10 ~16자 이내',
            placeholderPw3: '영문, 숫자, 특수문자 10 ~16자 이내',
            alertRequiredShow: false
        }
    },

    setup() {
        const loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO));
        const route = useRoute();
        const router = useRouter();

        return {
            route, router, loginInfo
        };
    },
    methods: {
        async handleChange() {
            if (document.querySelector("#password").value == '') {
                //document.querySelector("#password").focus();
                //alert('패스워드를 입력해 주세요');
                this.alertContent = '패스워드를 입력해 주세요'
                this.alertRequiredShow = true;
                return false;
            }

            if (document.querySelector("#passwordNew").value == '') {
                // document.querySelector("#passwordRe").focus();
                // alert('패스워드 확인을 입력해 주세요');
                this.alertContent = '패스워드 확인을 입력해 주세요'
                this.alertRequiredShow = true;
                return false;
            }

            if (document.querySelector("#passwordNew").value != document.querySelector("#passwordNewConf").value) {
                //document.querySelector("#password").focus();
                //alert('패스워드가 일치 하지 않습니다');
                this.alertContent = '패스워드가 일치 하지 않습니다'
                this.alertRequiredShow = true;
                return false;
            }

            const checkPwd = this.validatePassword();
            if (checkPwd == false) {
                //alert('패스워드 규칙이 맞지 않습니다')
                this.alertContent = '패스워드 규칙이 맞지 않습니다'
                this.alertRequiredShow = true;
                return false;
            } else {
                console.log(checkPwd)
            }


            try {
                const loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO));

                const response = await postAxios('/bgm/v1/auth/change/pwd', {

                    "id": loginInfo.id,
                    "oldPassword": document.querySelector("#password").value,
                    "newPassword": document.querySelector("#passwordNew").value,
                });

                console.log("response", response);

                this.alertContent = '패스워드가 변경이 완료 되었습니다'
                this.alertRequiredShow = true;

                // 가입 성공 후 리다이렉트
                setTimeout(() => {
                    const redirect = this.route.query.redirect || '/HFO_MP_003';
                    this.router.push({ path: redirect });
                }, "1000");
            } catch (error) {
                // 오류 처리
                console.error('로그인 중 오류가 발생했습니다:', error);

                // 에러 메시지 표시
                if (error.status === 400) {
                    this.invalidPassword = true;
                }
            }
        }, validatePassword() {
            console.log(document.querySelector("#passwordNew").value);
            const password = document.querySelector("#passwordNew").value;
            const pwdPattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()])[a-zA-Z\d!@#$%^&*()]{8,12}$/;

            const checkpwd = pwdPattern.test(password);

            console.log(checkpwd)
            return checkpwd;


        }
    }
}
</script>